// extracted by mini-css-extract-plugin
module.exports = {"bkw-F":"F_bkw-F__D2iAI"};